import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgComment = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M4.312 15a.7.7 0 0 0 .392-.116q.182-.108.443-.347l2.62-2.385h4.908q1.082 0 1.822-.383a2.53 2.53 0 0 0 1.118-1.12Q16 9.91 16 8.848V3.31q0-1.064-.385-1.8A2.53 2.53 0 0 0 14.497.39Q13.757 0 12.675 0h-9.35Q2.243 0 1.503.39A2.57 2.57 0 0 0 .377 1.51Q0 2.249 0 3.31v5.538q0 1.063.377 1.8.385.738 1.126 1.12.74.384 1.822.384h.341v2.103q0 .34.167.543.167.201.48.202M4.145 4.02a.44.44 0 0 1-.312-.124.44.44 0 0 1-.123-.31q0-.18.123-.304a.44.44 0 0 1 .312-.123h7.615q.182 0 .305.123a.4.4 0 0 1 .131.304q0 .18-.13.31a.42.42 0 0 1-.306.123zm0 2.421a.42.42 0 0 1-.436-.434q0-.173.124-.303a.43.43 0 0 1 .312-.13h7.615q.182 0 .305.13.131.13.131.303a.4.4 0 0 1-.13.311.42.42 0 0 1-.306.123zm0 2.429a.44.44 0 0 1-.312-.123.41.41 0 0 1-.123-.304.42.42 0 0 1 .123-.31.43.43 0 0 1 .312-.13h4.951q.182 0 .305.13.13.122.13.31a.4.4 0 0 1-.13.304.42.42 0 0 1-.305.123z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgComment);
export default ForwardRef;
